import React from 'react';
import styled from 'styled-components';

import Button from '../../common/ui/Button';

import DesktopLinkGroup from './DesktopLinkGroup';
import MobileMenu from './MobileMenu';

const Actions = (props) => {
  const { mode } = props;
  return (
    <Wrapper>
      <StyledDesktopLinkGroup
        href="https://admin.platform.commerce7.com/login"
        label="Login"
        mode={mode}
      />
      <StyledButton to="/demo">Book a Demo</StyledButton>
      <MobileMenu mode={mode} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledButton = styled(Button)`
  height: 46px;
  margin-left: 20px;
  display: none;

  ${({ theme }) => `
    @media ${theme.mediumUp} {
      display: inline-flex;
    }
  `}
`;

const StyledDesktopLinkGroup = styled(DesktopLinkGroup)`
  display: none;

  ${({ theme }) => `
    @media ${theme.mediumUp} {
      display: block
    }
  `}
`;

export default Actions;
